import { render, staticRenderFns } from "./setup-theme.vue?vue&type=template&id=5b59901b"
import script from "./setup-theme.vue?vue&type=script&lang=js"
export * from "./setup-theme.vue?vue&type=script&lang=js"
import style0 from "./setup-theme.vue?vue&type=style&index=0&id=5b59901b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports